const toDate = (ts: string | number) => new Date(Number(ts) * 1000)

export function formatTime(ts: string | number): string {
  return toDate(ts).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
}

export function dayKey(ts: string | number): string {
  const d = toDate(ts)
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`
}

export function formatDay(ts: string | number): string {
  const d = toDate(ts)
  const today = new Date()
  const yesterday = new Date()
  yesterday.setDate(today.getDate() - 1)
  if (d.toDateString() === today.toDateString()) return 'Today'
  if (d.toDateString() === yesterday.toDateString()) return 'Yesterday'
  return d.toLocaleDateString([], {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: d.getFullYear() === today.getFullYear() ? undefined : 'numeric',
  })
}

export function formatDateTime(ts: string | number): string {
  const d = toDate(ts)
  return `${formatDay(ts)} at ${d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`
}

export function formatShortDate(ts: string | number): string {
  const d = toDate(ts)
  const sameYear = d.getFullYear() === new Date().getFullYear()
  return d.toLocaleDateString([], { month: 'short', day: 'numeric', year: sameYear ? undefined : 'numeric' })
}

export function formatBytes(n?: number): string {
  if (!n) return ''
  const units = ['B', 'KB', 'MB', 'GB']
  let i = 0
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024
    i++
  }
  return `${n.toFixed(i === 0 ? 0 : 1)} ${units[i]}`
}

/** Formats a Slack <!date^ts^format|fallback> token. */
export function formatSlackDate(ts: number, format: string): string {
  const d = new Date(ts * 1000)
  return format
    .replace('{date_num}', d.toLocaleDateString())
    .replace('{date_short_pretty}', formatDay(ts))
    .replace('{date_long_pretty}', formatDay(ts))
    .replace('{date_pretty}', formatDay(ts))
    .replace('{date_short}', d.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' }))
    .replace('{date_long}', d.toLocaleDateString([], { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }))
    .replace('{date}', d.toLocaleDateString([], { month: 'long', day: 'numeric', year: 'numeric' }))
    .replace('{time_secs}', d.toLocaleTimeString())
    .replace('{time}', d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }))
}

/** Local time in another IANA zone, e.g. for profile cards. */
export function localTimeIn(tz?: string): string | null {
  if (!tz) return null
  try {
    return new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', timeZone: tz })
  } catch {
    return null
  }
}
